import type { Ref, ComputedRef } from 'vue'
import type { Stock } from '@/entities/stock'
import type { Company } from '@/entities/company'

export interface UseFormatStock {
  stock: ComputedRef<Stock | null>
  stockSymbol: ComputedRef<string[]>
}

export function useFormatStock(company: Readonly<Ref<Company>>): UseFormatStock {
  const stock = computed(() => {
    if (!company.value?.stocks?.length) return null
    return company.value.stocks?.[0] ? company.value.stocks[0] : null
  })

  const stockSymbol = computed(() => {
    if (!company.value.stock_symbol) return []
    return company.value.stock_symbol.split('.')
  })

  return { stock, stockSymbol }
}
